// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_REQUEST = 'FETCH_YARN_PO_REQUEST';
export const FETCH_YARN_PO_SUCCESS = 'FETCH_YARN_PO_SUCCESS';
export const FETCH_YARN_PO_FAILURE = 'FETCH_YARN_PO_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_WITHOUT_FILTER_REQUEST = 'FETCH_YARN_PO_WITHOUT_FILTER_REQUEST';
export const FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS = 'FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS';
export const FETCH_YARN_PO_WITHOUT_FILTER_FAILURE = 'FETCH_YARN_PO_WITHOUT_FILTER_FAILURE';

export const FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST = 'FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_REQUEST';
export const FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS = 'FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_SUCCESS';
export const FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE = 'FETCH_KNITTING_DC_SUPPLIER_LIST_BASED_ON_PROGRAM_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_SECTION_LIST_REQUEST = 'FETCH_YARN_PO_SECTION_LIST_REQUEST';
export const FETCH_YARN_PO_SECTION_LIST_SUCCESS = 'FETCH_YARN_PO_SECTION_LIST_SUCCESS';
export const FETCH_YARN_PO_SECTION_LIST_FAILURE = 'FETCH_YARN_PO_SECTION_LIST_FAILURE';

export const FETCH_YARN_PO_UNIT_LIST_REQUEST = 'FETCH_YARN_PO_UNIT_LIST_REQUEST';
export const FETCH_YARN_PO_UNIT_LIST_SUCCESS = 'FETCH_YARN_PO_UNIT_LIST_SUCCESS';
export const FETCH_YARN_PO_UNIT_LIST_FAILURE = 'FETCH_YARN_PO_UNIT_LIST_FAILURE';

export const FETCH_YARN_PO_SUPPLIER_LIST_REQUEST = 'FETCH_YARN_PO_SUPPLIER_LIST_REQUEST';
export const FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS = 'FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS';
export const FETCH_YARN_PO_SUPPLIER_LIST_FAILURE = 'FETCH_YARN_PO_SUPPLIER_LIST_FAILURE';

export const FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST = 'FETCH_YARN_PO_PENDING_SUPPLIER_LIST_REQUEST';
export const FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS = 'FETCH_YARN_PO_PENDING_SUPPLIER_LIST_SUCCESS';
export const FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE = 'FETCH_YARN_PO_PENDING_SUPPLIER_LIST_FAILURE';

export const FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST = 'FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_REQUEST';
export const FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS = 'FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_SUCCESS';
export const FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE = 'FETCH_YARN_PO_PENDING_DELIVERY_AT_LIST_FAILURE';

export const FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST = 'FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST';
export const FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS = 'FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS';
export const FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE = 'FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_PROGRAM_LIST_REQUEST = 'FETCH_YARN_PO_PROGRAM_LIST_REQUEST';
export const FETCH_YARN_PO_PROGRAM_LIST_SUCCESS = 'FETCH_YARN_PO_PROGRAM_LIST_SUCCESS';
export const FETCH_YARN_PO_PROGRAM_LIST_FAILURE = 'FETCH_YARN_PO_PROGRAM_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_SALES_ORDER_REQUEST = 'FETCH_YARN_PO_SALES_ORDER_REQUEST';
export const FETCH_YARN_PO_SALES_ORDER_SUCCESS = 'FETCH_YARN_PO_SALES_ORDER_SUCCESS';
export const FETCH_YARN_PO_SALES_ORDER_FAILURE = 'FETCH_YARN_PO_SALES_ORDER_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST';
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS';
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_YARN_PO_REQUEST = 'CREATE_YARN_PO_REQUEST';
export const CREATE_YARN_PO_SUCCESS = 'CREATE_YARN_PO_SUCCESS';
export const CREATE_YARN_PO_FAILURE = 'CREATE_YARN_PO_FAILURE';

//FETCH INVOICE DATA
export const FETCH_YARN_PO_INVOICE_REQUEST = 'FETCH_YARN_PO_INVOICE_REQUEST';
export const FETCH_YARN_PO_INVOICE_SUCCESS = 'FETCH_YARN_PO_INVOICE_SUCCESS';
export const FETCH_YARN_PO_INVOICE_FAILURE = 'FETCH_YARN_PO_INVOICE_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_PO = 'CREATE_USER_FORM_YARN_PO';


// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_YARN_PO_REQUEST = 'UPDATE_YARN_PO_REQUEST';
export const UPDATE_YARN_PO_SUCCESS = 'UPDATE_YARN_PO_SUCCESS';
export const UPDATE_YARN_PO_FAILURE = 'UPDATE_YARN_PO_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_YARN_PO_REQUEST = 'FETCH_SINGLE_YARN_PO_REQUEST';
export const FETCH_SINGLE_YARN_PO_SUCCESS = 'FETCH_SINGLE_YARN_PO_SUCCESS';
export const FETCH_SINGLE_YARN_PO_FAILURE = 'FETCH_SINGLE_YARN_PO_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_YARN_PO_REQUEST = 'DELETE_YARN_PO_REQUEST';
export const DELETE_YARN_PO_SUCCESS = 'DELETE_YARN_PO_SUCCESS';
export const DELETE_YARN_PO_FAILURE = 'DELETE_YARN_PO_FAILURE';

// USERFORM RESET

export const YARN_PO_USERFORM_RESET = 'YARN_PO_USERFORM_RESET';
export const CREATE_USER_FORM_PROGRAM_WISE_REPORT = 'CREATE_USER_FORM_PROGRAM_WISE_REPORT';
export const PROGRAM_WISE_REPORT_RESET = 'PROGRAM_WISE_REPORT_RESET'

// navigate to unit component
export const NAVIGATE_YARN_PO_DETAILS = 'NAVIGATE_YARN_PO_DETAILS';
export const NAVIGATE_YARN_PO_PRINT = 'NAVIGATE_YARN_PO_PRINT';

// navigate to company component
export const NAVIGATE_YARN_PO = 'NAVIGATE_YARN_PO';
export const YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_REVERSE';

export const RESET_YARN_PO_INVOICE = 'RESET_YARN_PO_INVOICE';

//FETCH INVOICE DATA
export const FETCH_YARN_LOTNO_INVOICE_REQUEST = 'FETCH_YARN_LOTNO_INVOICE_REQUEST';
export const FETCH_YARN_LOTNO_INVOICE_SUCCESS = 'FETCH_YARN_LOTNO_INVOICE_SUCCESS';
export const FETCH_YARN_LOTNO_INVOICE_FAILURE = 'FETCH_YARN_LOTNO_INVOICE_FAILURE';

export const SET_UNIT_NAME_YARN_PO = 'SET_UNIT_NAME_YARN_PO';
export const SET_GRID_PAGE_INDEX_YARN_PO = 'SET_GRID_PAGE_INDEX_YARN_PO';

export const DELETE_BTN_UPDATE_API_REQUEST = 'DELETE_BTN_UPDATE_API_REQUEST';
export const DELETE_BTN_UPDATE_API_SUCCESS = 'DELETE_BTN_UPDATE_API_SUCCESS';
export const DELETE_BTN_UPDATE_API_FAILURE = 'DELETE_BTN_UPDATE_API_FAILURE';

export const OTP_API_POST_CLOSE_CALL_REQUEST = 'OTP_API_POST_CLOSE_CALL_REQUEST';
export const OTP_API_POST_CLOSE_CALL_SUCCESS = 'OTP_API_POST_CLOSE_CALL_SUCCESS';
export const OTP_API_POST_CLOSE_CALL_FAILURE = 'OTP_API_POST_CLOSE_CALL_FAILURE';

export const OTP_API_POST_CLOSE_ALL_CALL_REQUEST = 'OTP_API_POST_CLOSE_ALL_CALL_REQUEST';
export const OTP_API_POST_CLOSE_ALL_CALL_SUCCESS = 'OTP_API_POST_CLOSE_ALL_CALL_SUCCESS';
export const OTP_API_POST_CLOSE_ALL_CALL_FAILURE = 'OTP_API_POST_CLOSE_ALL_CALL_FAILURE';


export const FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST = 'FETCH_READYGARMENT_PO_SALES_ORDER_REQUEST';
export const FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS = 'FETCH_READYGARMENT_PO_SALES_ORDER_SUCCESS';
export const FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE = 'FETCH_READYGARMENT_PO_SALES_ORDER_FAILURE';

export const EDIT_API_SELECTED_ROWS_CALL_REQUEST = 'EDIT_API_SELECTED_ROWS_CALL_REQUEST';
export const EDIT_API_SELECTED_ROWS_CALL_SUCCESS = 'EDIT_API_SELECTED_ROWS_CALL_SUCCESS';
export const EDIT_API_SELECTED_ROWS_CALL_FAILURE = 'EDIT_API_SELECTED_ROWS_CALL_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = "HEADER_SEARCH_CALL_ONLOAD";

